import React, { useRef, useState, useCallback, useEffect } from "react";
import cn from "classnames";

import ChatMenu from "components/common/ChatMenu";

import styles from "./styles.module.scss";

const ChatMenuButton = ({
    contact,
    direction,
    conversationId,
    handleChatWindowClose,
    usePortal = false,
    ...props
}) => {
    const containerRef = useRef(null);
    const buttonRef = useRef(null);
    const menuRef = useRef(null);
    const [isMenuOpen, setMenuOpen] = useState(false);

    const handleToggleMenu = () => {
        setMenuOpen(!isMenuOpen);
    };

    const handleCloseMenu = useCallback(() => {
        setMenuOpen(false);
    }, []);

    const getButtonRect = useCallback(() => {
        if (buttonRef.current) {
            return buttonRef.current.getBoundingClientRect();
        }
        return null;
    }, []);

    // Закрытие при клике вне кнопки и меню
    useEffect(() => {
        const listener = (event) => {
            // Клик внутри контейнера с кнопкой
            if (containerRef.current && containerRef.current.contains(event.target)) {
                return;
            }
            // Клик внутри меню (в портале)
            if (menuRef.current && menuRef.current.contains(event.target)) {
                return;
            }
            handleCloseMenu();
        };
        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);
        return () => {
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, [handleCloseMenu]);

    return (
        <div ref={containerRef} className={styles.menu}>
            <button
                ref={buttonRef}
                className={cn(styles.menu__button, isMenuOpen && styles["menu__button--opened"])}
                onClick={handleToggleMenu}
                type="button"
            >
                <span className={styles["menu__circle"]} />
                <span className={styles["menu__circle"]} />
                <span className={styles["menu__circle"]} />
            </button>
            <ChatMenu
                onCloseMenu={handleCloseMenu}
                isOpen={isMenuOpen}
                contact={contact}
                direction={direction}
                conversationId={conversationId}
                handleChatWindowClose={handleChatWindowClose}
                usePortal={usePortal}
                getButtonRect={getButtonRect}
                menuRef={menuRef}
                {...props}
            />
        </div>
    );
};

export default ChatMenuButton;
